import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { apartments } from "../floor/apartmentsData";
import { FaDownload, FaEnvelope } from "react-icons/fa";
import "./ApartMap.css";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ApartmentDetails() {
  const { t } = useTranslation("portfolio");
  const query = useQuery();
  const id = query.get("id");
  const floor = query.get("floor");
  const entrance = query.get("entrance");
  const navigate = useNavigate();

  const apartment = apartments.find(
    (apt) =>
      apt.id === id &&
      String(apt.floor) === String(floor) &&
      apt.entrance === entrance
  );

  const getTranslatedStatus = (status) => {
    switch (status) {
      case "Свободен":
        return t("apartmentDetails.status.available");
      case "Резервиран":
        return t("apartmentDetails.status.reserved");
      case "Продаден":
        return t("apartmentDetails.status.sold");
      default:
        return status;
    }
  };

  if (!apartment) {
    return (
      <div style={{ padding: "40px", textAlign: "center" }}>
        {t("apartmentDetails.notFound")}
      </div>
    );
  }

  const imageUrl = `/innerpages/assets/img/apartments/${apartment.id}.png`;

  return (
    <div className="apartment-layout" id="apartment-layout">
      <div className="apartment-img">
        <div className="apartment-info-over-image">
          <div className="apartment-title apartment-title-over-image">
            {t("apartmentDetails.title", { id: apartment.id })}
            <span
              className={`status-badge ${
                apartment.status === "Свободен"
                  ? "available"
                  : apartment.status === "Продаден"
                  ? "sold"
                  : "reserved"
              }`}
            >
              {getTranslatedStatus(apartment.status)}
            </span>
          </div>

          <div className="apartment-info-row">
            <p>
              <strong>{t("apartmentDetails.floor")}</strong> {apartment.floor}
            </p>
            <p>
              <strong>{t("apartmentDetails.area")}</strong> {apartment.area}
            </p>

            <p>
              <a href={imageUrl} download={`apartment-${apartment.id}.png`}>
                <strong>Изтегли план</strong> <FaDownload />
              </a>
            </p>
            <p>
              <a
                href={`/innerpages/contact?subject=apartments&message=${encodeURIComponent(
                  `Запитване за апартамент: етаж ${apartment.floor}, площ ${apartment.area}`
                )}`}
                className="inquiry-button"
              >
                <strong>Изпрати запитване</strong> <FaEnvelope />
              </a>
            </p>
          </div>
        </div>

        <img
          src={imageUrl}
          alt={t("apartmentDetails.planAlt", { id: apartment.id })}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/innerpages/assets/img/floor/floor1.png"; // fallback
          }}
        />
      </div>
    </div>
  );
}

export default ApartmentDetails;
